// index.js or main file
import React, {useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Login from './pages/login/login';
import AdminRedirect from './adminRedirect/admin';
import Admin from './admin/admin';
import Home from './admin/pages/home/home';
import Rules from './admin/pages/rules/rules';
import { Provider } from 'react-redux';
import { store } from './admin/store';
import LoginPage from './admin/pages/login/login';
import UserRules from './pages/rules/rules';
import Lobby from './pages/lobby/lobby';
import Host from './pages/host/host';
import QuizUI from './pages/quiz/quizUI';
import QuestionsTable from './admin/pages/questions/questions';
import ManageTeams from './admin/pages/manageTeams/manageTeams';
import TeamWaiting from './pages/teamWaiting/TeamWaiting';
import ThankYou from './pages/thankyou/thankyou';
import USER from './pages/dddUI/user';
import JengaGame from './pages/jenga/JengaGame';
import Waiting from './pages/waiting/waiting';
import Leaderboard from './pages/leaderboard/leaderboard';
import Game from './pages/game/game';
import Modes from './pages/modes/modes';
import SpaceGame from './pages/spacegame/SpaceGame';


function usePageBackground() {
  const location = useLocation();
  useEffect(() => {
    const body = document.body;
    if (!location.pathname.startsWith("/admin")) {
      body.classList.add("common-bg");
    } else {
      body.classList.remove("common-bg");
    }
  }, [location]); 
}


function App() {
  usePageBackground();

   return (
    <Provider store={store}>
      <Routes>
        {/* Admin routes (no DDDUI wrapper) */}
        <Route path="/admin">
          <Route index element={<Admin><Home /></Admin>} />
          <Route path="rules" element={<Admin><Rules /></Admin>} />
          <Route path="questions" element={<Admin><QuestionsTable/></Admin>} />
          <Route path="manageTeams" element={<Admin><ManageTeams/></Admin>} />
          <Route path="superadmin" element={<LoginPage/>} />
        </Route>

        {/* Public routes wrapped with DDDUI */}
        <Route path="*" element={
          <USER>
            <Routes>
              <Route index element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/rules" element={<UserRules/>} />
              <Route path="/modes" element={<Modes/>} />
              <Route path="/spacegame" element={<SpaceGame/>} />
              <Route path="/lobby" element={<Lobby/>} />
              <Route path="/host" element={<Host/>} />
              <Route path="/quiz" element={<QuizUI/>} />
              <Route path="/jenga" element={<JengaGame/>} />
              <Route path="/leaderboard" element={<Leaderboard/>} />
              <Route path="/create-puzzle" element={<Navigate to="/host" replace />} />
              <Route path="/puzzle" element={<Navigate to="/game" replace />} />
              <Route path="/waiting" element={<Waiting/>} />
              <Route path="/teamWaiting" element={<TeamWaiting/>} />
              <Route path="/game" element={<Game/>} />
              <Route path="/AdminRedirect" element={<AdminRedirect />} />
              <Route path="/thankyou" element={<ThankYou/>} />
            </Routes>
          </USER>
        } />
      </Routes>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Performance reporting
reportWebVitals();
